import gql from 'graphql-tag';

export const addEventLanguage = gql`
  mutation addEventLanguage($input: [MEventLanguageInput!]!) {
    response: addEventLanguage(inputEventLanguage: $input) {
      _id
    }
  }
`;
